<template>
  <div class="home">
    <header class="nav">
      <div class="nav-left" @click="goTo('/')">
        <img class="logo" :src="logoSrc" alt="北磁商标" @error="onLogoError" />
        <span class="brand">北磁科技</span>
      </div>
      <div class="nav-center">
        <el-menu mode="horizontal" class="menu" :ellipsis="false">
          <el-menu-item index="home" class="menu-item" @click="goTo('/')">首页</el-menu-item>
          <el-menu-item index="company" class="menu-item" @click="scrollTo('company')">公司介绍</el-menu-item>
          <el-menu-item index="showcase" class="menu-item" @click="scrollTo('showcase')">供应设备</el-menu-item>
          <el-menu-item index="contact" class="menu-item" @click="scrollTo('contact')">联系我们</el-menu-item>
          <el-menu-item index="issue" class="menu-item" @click="scrollTo('login-ports')">工单系统</el-menu-item>
        </el-menu>
      </div>
      <div class="nav-right"></div>
    </header>
    <section class="hero">
      <el-carousel height="360px" indicator-position="outside" :autoplay="true" interval="5000" trigger="click">
        <el-carousel-item>
          <div class="slide" :style="slideStyle(0)">
            <div class="slide-content">
              <h1 class="hero-title">商用智能商厨设备源头工厂</h1>
              <p class="hero-sub">电磁灶 · 调汤机（骨汤机）· 煮面机 · 锅贴机，守护连锁餐饮出餐标准</p>
              <div class="hero-actions">
                <el-button type="primary" plain size="large" @click="scrollTo('showcase')">浏览产品</el-button>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="slide" :style="slideStyle(1)">
            <div class="slide-content">
              <h1 class="hero-title">物联网化餐饮设备</h1>
              <p class="hero-sub">在线监测与远程运维，智能告警与节能优化</p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="slide" :style="slideStyle(2)">
            <div class="slide-content">
              <h1 class="hero-title">数据结合与洞察</h1>
              <p class="hero-sub">设备数据驱动决策，开放接口融入业务</p>
              <div class="hero-actions">
                <el-button type="primary" plain size="large" @click="scrollTo('contact')">联系我们</el-button>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <section id="details" class="section">
      <h2 class="section-title">产品展示</h2>
      <div class="products-grid">
        <div class="product-card" v-for="(item, idx) in displayedShowcase" :key="item.title">
          <el-image
            class="product-image"
            :src="item.img"
            :preview-src-list="details"
            :initial-index="Math.max(0, details.indexOf(item.img))"
            fit="contain"
            @load="onDetailLoad(idx, $event)"
            :style="imageStyle(idx)"
            lazy
          />
          <div class="product-title">{{ item.title }}</div>
          <div class="product-desc">{{ item.desc }}</div>
          <div class="product-actions">
            <el-button type="primary" size="small" @click="scrollTo('contact')">咨询报价</el-button>
          </div>
        </div>
      </div>
      <div class="more-actions" v-if="showcaseItems.length > DEFAULT_VISIBLE">
        <el-button class="more-btn" round @click="showAllShowcase = !showAllShowcase">
          {{ showAllShowcase ? '收起' : `查看全部（共 ${showcaseItems.length} 项）` }}
        </el-button>
      </div>
    </section>
    <section id="company" class="section">
      <h2 class="section-title">公司介绍</h2>
      <div class="about">
        <p>北京智润天成节能设备有限公司，旗下品牌「北磁 NMAG」，创立于 2006 年，是国家高新技术企业（证书编号 GR202413004599）。公司总部与生产基地位于河北省邯郸市大名县圣中科技产业园东区 1 栋，自有约 5000 平方米现代化工厂，配备激光切割、精密焊接与机器人自动化生产线；研发与展厅设于河北廊坊固安华夏幸福创新中心 11 层。</p>
        <p>北磁专注商用智能电磁加热设备研发制造，产品覆盖电磁灶、炸炉、煮面机、煲仔炉、炒灶、调汤机（骨汤机）、泡粉机、锅贴机、保温消毒柜等 20 余款设备，贯穿煎炸、煮炖、调配、保温全流程，拥有 16 项专利，含多项软件著作权，合计知识产权 20 余项，产品通过欧盟 CE 认证。公司服务全国连锁餐饮品牌，已落地鱼你在一起、李先生牛肉面、海伦司、南城香、桂满陇、饼司令等 5000 余家终端门店。</p>
        <p>售后提供整机一年质保、全国联保，2 小时响应、4 小时到场。针对行业痛点，我们成功研制出智能配料机与高效节能煮面机等创新产品，实测数据显示，北磁节能自动煮面机相比市场同类产品，能耗最高可降低 45% 以上，以硬核科技切实帮助客户降本增效。</p>
      </div>
    </section>
    <section id="showcase" class="section section-alt">
      <h2 class="section-title">供应设备</h2>
      <div class="products-grid compact-grid">
        <div class="product-card compact-card" v-for="item in displayedSupply" :key="item.title">
          <el-image class="product-image" :src="item.img" fit="contain" lazy />
          <div class="product-title">{{ item.title }}</div>
          <div class="product-actions">
            <el-button type="primary" size="small" @click="scrollTo('contact')">想要了解更多</el-button>
          </div>
        </div>
      </div>
      <div class="more-actions" v-if="supplyItems.length > DEFAULT_VISIBLE">
        <el-button class="more-btn" round @click="showAllSupply = !showAllSupply">
          {{ showAllSupply ? '收起' : `查看全部（共 ${supplyItems.length} 项）` }}
        </el-button>
      </div>
    </section>
    <section id="contact" class="section section-alt">
      <h2 class="section-title">联系我们</h2>
      <div class="about">
        <p>联系电话：<a href="tel:4000672725">4000672725</a></p>
        <p>商务合作与产品试用，请联系：25350521@qq.com</p>
        <p>我们将根据您的场景推荐合适的方案与产品组合。</p>
      </div>
    </section>
    <section id="login-ports" class="section">
      <h2 class="section-title">工单管理系统</h2>
      <div class="login-card">
        <div class="login-card-icon">🛠️</div>
        <h3 class="login-card-title">售后工单与保修协同平台</h3>
        <p class="login-card-desc">管理员与售后统一进入后台左侧菜单，售后可在“处理工单”菜单里执行状态流转、备注和指派操作，维修员仅处理小程序保修默认分配的保修单。</p>
        <el-button type="primary" size="large" class="login-btn" @click="goTo('/login')">登录系统</el-button>
      </div>
    </section>
    <footer class="footer">
      <div class="footer-inner">
        <div>© 2026 北磁科技</div>
        <div>联系我们：25350521@qq.com</div>
        <div>
          备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">冀ICP备2022027689号-1</a>
        </div>
      </div>
    </footer>
    <div class="contact-float-panel">
      <div class="contact-tab">联系我们</div>
      <div class="contact-pop">
        <div class="contact-title">联系信息</div>
        <div class="contact-line">电话：<a href="tel:4000672725">4000672725</a></div>
        <div class="contact-line">邮箱：<a href="mailto:25350521@qq.com">25350521@qq.com</a></div>
        <div class="contact-actions">
          <el-button size="small" type="primary" @click="callPhone">拨打电话</el-button>
          <el-button size="small" @click="sendMail">发送邮件</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import logo from '@/assets/logo.png'
const logoSrc = ref('/png/商标标题.png')
const heroImages = ref([
  '/png/轮播图1.png',
  '/png/轮播图2.png',
  '/png/轮播图3.jpg',
  '/png/轮播图4.jpg'
])
const deviceImages = ref([])
const detailImages = ref([])
const router = useRouter()
const userStore = useUserStore()
const isLoggedIn = userStore.isLoggedIn
const role = userStore.userInfo.role
const primaryText = isLoggedIn
  ? (role === 'ROLE_TECHNICIAN'
      ? '进入保修工作台'
      : '进入工单后台')
  : '立即登录'
const secondaryText = '查看我的工单'
const goTo = (path) => router.push(path)
const goPrimary = () => {
  if (!isLoggedIn) router.push('/login')
  else if (role === 'ROLE_TECHNICIAN') router.push('/fixer')
  else router.push('/admin')
}
const goSecondary = () => {
  if (!isLoggedIn) router.push('/login')
  else if (role === 'ROLE_TECHNICIAN') router.push('/fixer')
  else router.push('/admin')
}
const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
const supplyImages = ref([])
// 产品目录数据源：优先取后端主数据（/api/public/products），为空或失败时回退 /png 文件夹扫描
const publicProducts = ref([])
const PLACEHOLDER_IMG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="150"><rect width="100%" height="100%" fill="#f5f7fa"/><text x="50%" y="50%" font-size="13" fill="#909399" text-anchor="middle" dominant-baseline="middle">暂无图片</text></svg>'
)
const normalize = (name) =>
  name
    .replace(/\.[^.]+$/, '')
    .replace(/介绍|信息|图片/g, '')
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .trim()
const folderToItems = (list) => {
  return (list || []).map((url) => {
    const filename = (url.split('/').pop() || '')
    const title = normalize(filename)
    return { title, img: url, desc: '工业级材质与稳定性能，支持规格定制' }
  })
}
const findImageFor = (product) => {
  const pool = [...(detailImages.value || []), ...(supplyImages.value || [])]
  const key = String(product.productName || '').replace(/\s+/g, '')
  if (!key) return ''
  const hit = pool.find((url) => decodeURIComponent(url).replace(/\s+/g, '').includes(key))
  return hit || ''
}
const productsToItems = (list) => {
  return (list || []).map((p) => {
    const title = p.productName ? (p.productModel ? `${p.productName}（${p.productModel}）` : p.productName) : '未命名产品'
    return {
      title,
      desc: p.description || '工业级材质与稳定性能，支持规格定制',
      img: p.imageUrl || findImageFor(p) || PLACEHOLDER_IMG
    }
  })
}
const supplyItems = computed(() => {
  if (publicProducts.value.length) return productsToItems(publicProducts.value)
  return folderToItems(supplyImages.value)
})
const details = computed(() => {
  if (publicProducts.value.length) {
    return productsToItems(publicProducts.value).map((i) => i.img).filter((u) => u && u !== PLACEHOLDER_IMG)
  }
  return detailImages.value
})
const DEFAULT_VISIBLE = 4
const showAllShowcase = ref(false)
const showAllSupply = ref(false)
const showcaseItems = computed(() => {
  if (publicProducts.value.length) return productsToItems(publicProducts.value)
  return folderToItems(detailImages.value)
})
const displayedShowcase = computed(() =>
  showAllShowcase.value ? showcaseItems.value : showcaseItems.value.slice(0, DEFAULT_VISIBLE)
)
const displayedSupply = computed(() =>
  showAllSupply.value ? supplyItems.value : supplyItems.value.slice(0, DEFAULT_VISIBLE)
)
const fetchList = async (dir) => {
  try {
    const res = await fetch(`/png-list/${encodeURIComponent(dir)}/`)
    if (!res.ok) return []
    const data = await res.json()
    const files = Array.isArray(data)
      ? data.filter((item) => item?.type === 'file').map((item) => item.name)
      : (data.files || [])
    return files.map((f) => `/png/${dir}/${f}`)
  } catch (e) {
    return []
  }
}
const fetchPublicProducts = async () => {
  try {
    const res = await fetch('/api/public/products')
    if (!res.ok) return []
    const body = await res.json()
    return Array.isArray(body?.data) ? body.data : []
  } catch (e) {
    return []
  }
}
onMounted(async () => {
  const [d, x, s, prods] = await Promise.all([
    fetchList('纯设备图片'),
    fetchList('产品信息介绍图片'),
    fetchList('展示的产品'),
    fetchPublicProducts()
  ])
  deviceImages.value = d.slice(0, 6)
  detailImages.value = x
  supplyImages.value = s
  publicProducts.value = prods
})
const slideStyle = (idx) => {
  const bg = heroImages.value[idx % (heroImages.value.length || 1)] || ''
  const gradients = [
    'linear-gradient(90deg, rgba(6,24,48,0.76) 0%, rgba(6,24,48,0.56) 60%)',
    'linear-gradient(90deg, rgba(6,24,48,0.72) 0%, rgba(6,24,48,0.50) 60%)',
    'linear-gradient(90deg, rgba(6,24,48,0.68) 0%, rgba(6,24,48,0.44) 60%)'
  ]
  const gradient = gradients[idx % gradients.length]
  return {
    backgroundImage: bg ? `${gradient}, url('${bg}')` : gradient,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundBlendMode: 'multiply'
  }
}
const onLogoError = () => {
  logoSrc.value = logo
}
const detailRatios = ref({})
const onDetailLoad = (idx, e) => {
  const t = e?.target || e
  const w = t?.naturalWidth
  const h = t?.naturalHeight
  if (w && h) {
    detailRatios.value[idx] = Number((w / h).toFixed(4))
  }
}
const imageStyle = (idx) => {
  const aspectRatio = detailRatios.value[idx]
  return aspectRatio ? { aspectRatio } : {}
}
const callPhone = () => { window.location.href = 'tel:4000672725' }
const sendMail = () => { window.location.href = 'mailto:25350521@qq.com' }
</script>
<style scoped>
.home {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(180deg, #1e6fd0 0%, #1a4f9e 40%, #0f2f5c 75%, #091f3d 100%);
  background-attachment: fixed;
  color: #e5eaf5;
}

/* ===== 顶部导航 ===== */
.nav {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 32px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  color: #111827;
}
.nav-left {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;
}
.logo { height: 36px; width: auto; object-fit: contain; }
.brand {
  font-weight: 700;
  font-size: 20px;
  color: #0f2f5c;
  white-space: nowrap;
  letter-spacing: 1px;
}
.nav-center { display: flex; align-items: center; color: #111827; flex: 1; justify-content: center; }
.menu {
  border-bottom: none;
  color: #111827;
  --el-menu-bg-color: transparent;
  --el-menu-text-color: #374151;
  --el-menu-hover-text-color: #1e6fd0;
  --el-menu-active-color: #1e6fd0;
  --el-menu-hover-bg-color: transparent;
}
.menu-item { color: inherit; font-weight: 500; }
.nav-right { display: flex; gap: 10px; flex-shrink: 0; }

/* ===== Hero 轮播 ===== */
.hero { }
.slide { height: 100%; display: flex; align-items: center; justify-content: center; }
.slide-content { max-width: 1080px; width: 100%; padding: 0 24px; text-align: center; }
.hero-title { font-size: 42px; line-height: 1.2; margin: 0; font-weight: 700; color: #fff; text-shadow: 0 2px 16px rgba(0,0,0,0.4); }
.hero-sub { margin-top: 16px; font-size: 17px; color: rgba(255,255,255,0.88); text-shadow: 0 1px 8px rgba(0,0,0,0.35); }
.hero-actions { margin-top: 28px; display: flex; gap: 12px; justify-content: center; }

/* ===== 通用区块 ===== */
.section { padding: 64px 24px; }
.section-alt { background: rgba(255, 255, 255, 0.04); }
.section-title {
  position: relative;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
  color: #fff;
  letter-spacing: 1px;
}
.section-title::after {
  content: '';
  display: block;
  width: 56px;
  height: 4px;
  border-radius: 2px;
  margin: 14px auto 0;
  background: linear-gradient(90deg, #60a5fa, #3b82f6);
}

/* ===== 公司介绍 / 联系我们文本卡片 ===== */
.about {
  max-width: 880px;
  margin: 0 auto;
  font-size: 15px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.9);
  display: grid;
  gap: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  padding: 32px 36px;
  backdrop-filter: blur(6px);
}
#contact .about a { color: #ffd666; text-decoration: none; border-bottom: 1px dashed rgba(255,214,102,0.65); }
#contact .about a:hover { color: #ffe58f; border-bottom-color: #ffe58f; }

/* ===== 产品卡片 ===== */
.products-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; max-width: 1100px; margin: 0 auto; }
.product-card {
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 14px;
  padding: 18px;
  background: #fff;
  display: grid;
  gap: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  transition: transform 0.28s ease, box-shadow 0.28s ease;
}
.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.22);
}
.product-image { width: 100%; height: 170px; object-fit: contain; border-radius: 10px; background: #f5f7fa; }
.product-title { font-size: 16px; font-weight: 600; color: #111827; }
.product-desc { font-size: 13px; color: #6b7280; line-height: 1.6; }
.product-actions { display: flex; gap: 8px; }

/* 查看更多按钮 */
.more-actions { display: flex; justify-content: center; margin-top: 28px; }
.more-btn {
  padding: 0 32px;
  height: 42px;
  font-weight: 600;
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.35);
  transition: all 0.25s;
}
.more-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: #fff;
  color: #fff;
}

/* 供应设备：压缩展示 */
.compact-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; }
.compact-card { padding: 12px; gap: 8px; }
.compact-card .product-image { height: 120px; border-radius: 8px; }
.compact-card .product-title { font-size: 14px; text-align: center; }
.compact-card .product-actions { justify-content: center; }

/* ===== 登录入口卡片 ===== */
.login-card {
  max-width: 480px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 18px;
  padding: 36px 32px;
  text-align: center;
  backdrop-filter: blur(8px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}
.login-card-icon { font-size: 44px; margin-bottom: 8px; }
.login-card-title { margin: 0 0 12px; font-size: 20px; font-weight: 700; color: #fff; }
.login-card-desc { margin: 0 0 24px; font-size: 14px; line-height: 1.7; color: rgba(255,255,255,0.82); }
.login-btn { padding: 0 40px; border-radius: 24px; font-weight: 600; }

/* ===== 页脚 ===== */
.footer { margin-top: auto; padding: 28px 24px; background: #081a33; color: #b6c2d6; }
.footer-inner { display: flex; flex-wrap: wrap; gap: 12px; justify-content: space-between; max-width: 1100px; margin: 0 auto; }
.footer a { color: #b6c2d6; text-decoration: none; border-bottom: 1px dashed rgba(255,255,255,0.3); }
.footer a:hover { color: #fff; border-bottom-color: #fff; }

/* ===== 浮动联系面板 ===== */
.contact-float-panel { position: fixed; left: 16px; bottom: 16px; z-index: 50; color: #303133; }
.contact-tab { background: #ffffff; border: 1px solid #ebeef5; border-radius: 999px; box-shadow: 0 6px 16px rgba(17,24,39,0.18); padding: 10px 16px; font-weight: 600; cursor: pointer; transition: transform 0.2s; }
.contact-tab:hover { transform: translateY(-2px); }
.contact-pop { display: none; position: absolute; left: 0; bottom: 48px; background: #ffffff; border: 1px solid #ebeef5; border-radius: 14px; box-shadow: 0 12px 28px rgba(17,24,39,0.24); padding: 16px; width: 260px; gap: 8px; }
.contact-float-panel:hover .contact-pop { display: grid; }
.contact-title { font-weight: 700; color: #111827; }
.contact-line { font-size: 13px; color: #4b5563; }
.contact-actions { display: flex; gap: 8px; margin-top: 4px; }

/* ===== 产品展示（details）===== */
#details .products-grid { gap: 16px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
#details .product-card { border: none; padding: 0; background: transparent; box-shadow: none; }
#details .product-card:hover { transform: translateY(-4px); box-shadow: none; }
#details .product-image { width: 100%; height: auto; max-height: 480px; object-fit: contain; background: transparent; border-radius: 12px; }
#details .product-title { color: #fff; }
#details .product-desc { color: rgba(255,255,255,0.78); }

/* ===== 响应式 ===== */
@media (max-width: 1024px) {
  .products-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .compact-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 640px) {
  .nav { padding: 10px 16px; }
  .nav-center { display: none; }
  .section { padding: 44px 16px; }
  .products-grid { grid-template-columns: repeat(1, minmax(0, 1fr)); }
  .compact-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  #details .products-grid { grid-template-columns: repeat(1, minmax(0, 1fr)); }
  .hero-title { font-size: 28px; }
  .about { padding: 24px 20px; }
}
</style>
